<template>
  <div class="banner">
    <img :src="bannerInfo.img" alt />

    <div class="width flex_items banner_text">
      <div class>
        <div class="banner_title">{{bannerInfo.desc.title}}</div>
        <div class="banner_con">
          <div>{{bannerInfo.desc.text}}</div>
          <div>{{bannerInfo.desc.text2}}</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    bannerInfo: {
      default: {
        img: "",
        desc: {
          title: "这是标题",
          text: "这是文案1",
          text2: "这是文案2",
        },
      },
    },
  },
  data() {
    return {};
  },
};
</script>
<style lang="less" scoped>
.banner {
  position: relative;

  .banner_text {
    position: absolute;
    top: 50%;
    width: 1100px;
    left: 50%;
    transform: translate(-50%, -50%);
    color: @whiteColor;

    .banner_title {
      font-size: 42px;
      margin-bottom: 20px;
    }

    .banner_con {
      line-height: 40px;
      font-size: 20px;
    }
  }
}

@media screen and (max-width: 1100px) {
  .banner {
    .banner_text {
      width: 92%;

      .banner_title {
        font-size: 14px;
      }

      .banner_con {
        font-size: 12px;
        line-height: 18px;
      }
    }
  }
}
</style>